// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3WOXD","content":"ManualTimeModal_content__bfF_C"};